// removed by extract-text-webpack-plugin
module.exports = {"info-box":"info-box__info-box___dZ6jf","warning":"info-box__warning___2CdIT","error":"info-box__error___2Sg0c","info-box-title":"info-box__info-box-title___1Y1j0","info-box-body":"info-box__info-box-body___xmvsQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/info-box/info-box.scss
// module id = 1233
// module chunks = 0